module.exports = {"220723100":"乾安镇","220723101":"大布苏镇","220723102":"水字镇","220723103":"让字镇","220723104":"所字镇","220723105":"安字镇","220723200":"余字乡","220723201":"道字乡","220723202":"严字乡","220723203":"赞字乡","220723400":"国营林场","220723401":"腾字种畜场","220723402":"大遐畜牧场","220723403":"乾安鹿场","220723404":"来字良种繁育基地","220723405":"地字种畜场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220723.json
// module id = 600
// module chunks = 0